import { CalculateParamsTy } from '../../../baseComponents/Displays/DisplayPrice/types';
import { getPreparePricesConfigParam } from '../../reducers/getters';
import { SpecificPriceRulesPayload } from '../../reducers/products/specificPriceRules';

interface CalculateParamsWithSpecificPriceProps {
    specificPriceRules: SpecificPriceRulesPayload
    SpecificPriceRuleId: number
}
const useCalculateParamsWithSpecificPrice = ({ SpecificPriceRuleId, specificPriceRules }: CalculateParamsWithSpecificPriceProps) => {
    const calculateParamsDefault = getPreparePricesConfigParam()

    return {
        decimals: specificPriceRules?.dictionary?.[SpecificPriceRuleId]?.decimals || calculateParamsDefault?.decimals,
        rounding: specificPriceRules?.dictionary?.[SpecificPriceRuleId]?.rounding || calculateParamsDefault?.rounding,
        roundingPriceType: calculateParamsDefault?.roundingPriceType || calculateParamsDefault?.roundingPriceType
    } as CalculateParamsTy
}

export default useCalculateParamsWithSpecificPrice